import React from 'react';
type TextAreaFieldProps = {
  label: string;
  name: string;
  error?: string;
  optional?: boolean;
  className?: string;
} & Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'name' | 'className'>;
export function TextAreaField({
  label,
  name,
  error,
  optional,
  className = '',
  id,
  rows = 5,
  ...rest
}: TextAreaFieldProps) {
  const fieldId = id ?? `f-${name}`;
  return <div className={className} data-id="element-212" data-mp="2wi322uiz5dds">
      <label htmlFor={fieldId} className="flex items-baseline justify-between text-[0.7rem] font-medium uppercase tracking-[0.2em] text-charcoal" data-id="element-213" data-mp="2whbkwoq4ji71">
        <span data-id="element-214" data-mp="2sj3zhgkptspi">{label}</span>
        {optional && <span className="text-xs font-normal normal-case tracking-normal text-graphite" data-id="element-215" data-mp="36gsnuydzrhzb">Optional</span>}
      </label>
      <textarea id={fieldId} name={name} rows={rows} aria-invalid={error ? true : undefined} aria-describedby={error ? `${fieldId}-err` : undefined} className="field mt-2 resize-y" {...rest} data-id="element-216" data-mp="31ir2g6t3f6ko" />
      {error && <p id={`${fieldId}-err`} className="mt-2 text-sm text-[#9B2C2C]" data-id="element-217" data-mp="3a4x0v9at6d7k">
          {error}
        </p>}
    </div>;
}